enum ComponentLocation {
	TitleBar,
	ListRow
}

export default ComponentLocation;